/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Did Not Finish subtracts points from that session instead of adding them, and a disqualification costs more than a DNF since it wipes out the result entirely. These penalties apply per driver, so one bad result doesn't just cost that driver — it also drags down their constructor's combined total for the weekend.`)
};

const es_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un abandono resta puntos de esa sesión en lugar de sumarlos, y una descalificación cuesta más que un abandono porque anula el resultado por completo. Estas penalizaciones se aplican por piloto, así que un mal resultado no solo perjudica a ese piloto — también reduce el total combinado de su constructor esa jornada.`)
};

const de_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Ausfall zieht Punkte von dieser Session ab, statt welche hinzuzufügen, und eine Disqualifikation kostet mehr als ein Ausfall, da sie das Ergebnis komplett annulliert. Diese Strafen gelten pro Fahrer — ein schlechtes Ergebnis kostet also nicht nur diesen Fahrer, sondern drückt auch die kombinierte Gesamtpunktzahl seines Konstrukteurs für das Wochenende.`)
};

const nl_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een uitval trekt punten af van die sessie in plaats van ze toe te voegen, en een diskwalificatie kost meer dan een uitval omdat het resultaat volledig wordt geschrapt. Deze straffen gelden per coureur, dus een slecht resultaat kost niet alleen die coureur punten — het drukt ook het gecombineerde totaal van zijn constructeur voor dat weekend.`)
};

const fr_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un abandon retire des points de cette session au lieu d'en ajouter, et une disqualification coûte plus cher qu'un abandon puisqu'elle annule complètement le résultat. Ces pénalités s'appliquent par pilote, donc un mauvais résultat ne pénalise pas que ce pilote — il fait aussi baisser le total combiné de son constructeur pour le week-end.`)
};

const it_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ritiro sottrae punti da quella sessione invece di aggiungerli, e una squalifica costa più di un ritiro perché annulla completamente il risultato. Queste penalità si applicano per pilota, quindi un brutto risultato non penalizza solo quel pilota — abbassa anche il totale combinato del suo costruttore per il weekend.`)
};

const pt_br2_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um abandono subtrai pontos daquela sessão em vez de somar, e uma desclassificação custa mais do que um abandono, pois anula o resultado por completo. Essas penalidades valem por piloto, então um resultado ruim não prejudica só aquele piloto — também derruba o total combinado do construtor dele naquele fim de semana.`)
};

const pt_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um abandono subtrai pontos dessa sessão em vez de os somar, e uma desqualificação custa mais do que um abandono, pois anula o resultado por completo. Estas penalizações aplicam-se por piloto, por isso um mau resultado não prejudica apenas esse piloto — também reduz o total combinado do seu construtor nesse fim de semana.`)
};

const ja_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リタイアはそのセッションのポイントを加算ではなく減算し、失格はリタイアよりもさらにポイントを失います。結果そのものが完全に無効になるためです。これらのペナルティはドライバーごとに適用されるため、悪い結果はそのドライバーだけでなく、そのコンストラクターのその週末の合計ポイントも押し下げます。`)
};

const zh_f1_fp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退赛会从该环节中扣除积分而不是增加积分，而取消资格比退赛扣分更多，因为它会使成绩完全作废。这些处罚按车手单独计算，所以一次糟糕的结果不仅会影响该车手，还会拉低其车队当周的合计积分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_faq3_a", locale)
	if (locale === "en") return en_f1_fp_faq3_a(inputs)
	if (locale === "es") return es_f1_fp_faq3_a(inputs)
	if (locale === "de") return de_f1_fp_faq3_a(inputs)
	if (locale === "nl") return nl_f1_fp_faq3_a(inputs)
	if (locale === "fr") return fr_f1_fp_faq3_a(inputs)
	if (locale === "it") return it_f1_fp_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_faq3_a(inputs)
	if (locale === "pt") return pt_f1_fp_faq3_a(inputs)
	if (locale === "ja") return ja_f1_fp_faq3_a(inputs)
	return zh_f1_fp_faq3_a(inputs)
};